


























































import { Component, Vue, Prop } from 'vue-property-decorator';
import router from '../../router';
import { vxm } from '../../store.vuex';
import RegistrationCard from './Card.vue';
import Container from './Container.vue';

@Component({
  name: 'RetrievedEmailSignupPreference',
  components: {
    RegistrationCard,
    Container,
  },
})
export default class RetrievedEmailSignupPreference extends Vue {
  private retrievedEmail: string = '';
  private signupPreference: string = '';
  $wlToastr: any;

  setOAuthProvider(provider: string) {
    this.$cookies.set('OAuthProvider', provider, 300);
  }

  setOAuthRegistrationType(rtype: string) {
    console.log('C setOAuthRegistrationType:', rtype);
    this.$cookies.set('OAuthRegistrationType', rtype, 300);
  }

  redirectLogin() {
    console.log('Redirecting to login');
    vxm.users.setPopulateSignupPage(false);
    vxm.users.setDuplicateCheckRequired(true);
    router.push({ name: 'Signup' });
  }

  redirectValidate() {
    const vm = this;
    if (this.signupPreference === 'pref1') {
      this.setOAuthRegistrationType('');
      this.setOAuthProvider('');
      vxm.users.setEmail(vxm.users.UserParams.retrievedEmail);
      router.push({ name: 'Signup' });
    } else {
      if (vxm.users.UserParams.socialMediaType === 'google') {
        this.setOAuthRegistrationType('google-register');
        this.setOAuthProvider('google');
      } else if (vxm.users.UserParams.socialMediaType === 'facebook') {
        this.setOAuthRegistrationType('facebook-register');
        this.setOAuthProvider('facebook');
      } else if (vxm.users.UserParams.socialMediaType === 'linkedin') {
        this.setOAuthRegistrationType('linkedin-register');
        this.setOAuthProvider('linkedin');
      }
      router.push({
        name: 'Signup',
        query: {
          firstName: vxm.users.UserParams.firstName,
          lastName: vxm.users.UserParams.lastName,
          email: vxm.users.UserParams.email,
        },
      });
    }
  }
}
